'use client';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { BuyerListingFavorite } from '@/legacy/favorites/FavoritesViewModel';
import { WishlistsWithMetadata } from '../../wishlist/types';
import Section from '../Section';
import { FlatBuyerPreferences, ListingHomePageRecommendation } from '../types';
import { AlgoliaIndexWrapper } from './AlgoliaIndexWrapper';
import { PreferencesButton } from './PreferencesButton';

type Props = {
  categoriesPromise: Promise<{ [key: string]: string[] }>;
  favoritesPromise: Promise<BuyerListingFavorite[]>;
  listingHomePageRecommendationsPromise: Promise<ListingHomePageRecommendation[]>;
  listingsIndexName: string;
  preferencesPromise: Promise<FlatBuyerPreferences>;
  wishlistsPromise: Promise<WishlistsWithMetadata>;
  isStockXSectionEnabled: boolean;
};

export const HandpickedForYouSection = ({
  categoriesPromise,
  favoritesPromise,
  listingHomePageRecommendationsPromise,
  listingsIndexName,
  preferencesPromise,
  wishlistsPromise,
  isStockXSectionEnabled,
}: Props) => {
  return (
    <Section background="light">
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h1" color="typographyDarkPrimary">
          Recommended For You
        </Typography>
        <PreferencesButton />
      </Stack>
      <Grid container columnSpacing={3} rowSpacing={5}>
        <AlgoliaIndexWrapper
          categoriesPromise={categoriesPromise}
          favoritesPromise={favoritesPromise}
          listingHomePageRecommendationsPromise={listingHomePageRecommendationsPromise}
          listingsIndexName={listingsIndexName}
          preferencesPromise={preferencesPromise}
          wishlistsPromise={wishlistsPromise}
          isStockXSectionEnabled={isStockXSectionEnabled}
        />
      </Grid>
    </Section>
  );
};
